export const errorTags = [
  {
    name: 'empty-vast',
    label: 'Empty VAST (No Ad)',
    category: 'Error Cases',
    description: 'Valid VAST document with no ads (local)',
    url: '/vast-tags/empty-no-ad.xml',
    expectedBehavior: 'aderror fires with appropriate error code',
  },
  {
    name: 'invalid-url',
    label: 'Invalid URL (404)',
    category: 'Error Cases',
    description: 'Non-existent URL to test network error handling',
    url: '/vast-tags/this-does-not-exist.xml',
    expectedBehavior: 'aderror fires with network error',
  },
  {
    name: 'malformed-xml',
    label: 'Malformed XML',
    category: 'Error Cases',
    description: 'Invalid/malformed VAST XML (via raw XML mode)',
    url: 'data:text/xml,<invalid>xml</malformed>',
    expectedBehavior: 'aderror fires with XML parsing error',
  },
];
